import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { translate } from 'lit-translate';
import { appState } from '../app.state';
import { actionRegistry } from '../actions/action-registry';
import { ActionIds } from '../actions/action.types';
import type { TimelineToolbarItem } from '../types/timeline-toolbar-item.interface';

/**
 * Issue filters toolbar item for o2d timeline views.
 *
 * Renders two buttons:
 * - Reset button: clears all active filters (dispatches filters.clear)
 * - Filter button: toggles the filter sidebar (dispatches sidebar.toggle)
 *
 * Includes a login guard: renders nothing when the user is not logged in.
 */
export const issueFiltersToolbarItem: TimelineToolbarItem = {
    id: 'issue-filters',
    position: 'start',
    order: -10,
    render: () => {
        if (!appState.isUserLoggedIn) {
            return nothing;
        }

        const totalAppliedFilters = appState.numberOfAppliedFilters;

        return html`
            <div class="filter-buttons topbar-element">
                <button type="button"
                        ?disabled=${totalAppliedFilters < 1}
                        data-disabled=${totalAppliedFilters < 1 ? 'true' : 'false'}
                        data-total=${totalAppliedFilters}
                        class=${classMap({
                            reset: true,
                            secondary: true,
                            'buttonform-marker': true,
                            'filter-applied': totalAppliedFilters > 0,
                        })}
                        @click=${() => actionRegistry.execute(ActionIds.FILTERS_CLEAR)}>
                    <div class="hover-effect"></div>
                </button>
                <button type="button"
                        class="filter buttonform-marker secondary"
                        data-label="${translate('toolbar.filter')}"
                        @click=${() => actionRegistry.execute(ActionIds.SIDEBAR_TOGGLE_TODO)}>
                    <div class="hover-effect"></div>
                </button>
            </div>
        `;
    },
};
